import { RouteListGetter } from 'App';
import React from 'react';
import { Route } from 'react-router-dom';

import { AppRoutes } from 'config/app-routes';

import PublicRoute from '.';

const getPublicRoutes: RouteListGetter = (lazily) => {
  const SignUp = lazily('sign-up');
  const NotFound = lazily('404');

  return (
    <Route path="/" element={<PublicRoute />}>
      <Route path={AppRoutes.SIGN_UP} element={<SignUp />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  );
};

export default getPublicRoutes;
